/**
 * This file is auto-generated from ChatStaffJoin.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const doctorJoined: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Doctor joined';
        case 'pl':
            return 'Lekarz dołączył';
    }
};

export const joinedChat: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Joined chat';
        case 'pl':
            return 'Dołączył do czatu';
    }
};
